import React, { useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './Confirmation.module.scss'
import printJS from 'print-js'

const PrintComponent = ({ t, transId, transOwner }) => {
  const baseURL = process.env.REACT_APP_SERVICE_URL

  const isSafari = useMemo(() => navigator.vendor.indexOf("Apple") !== -1, [])

  const printClick = async () => {
    try {
      if (transId && transOwner) {
        printJS({
          printable: getPrintPDFURL(),
          type: 'pdf',
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  const getPrintPDFURL = () => {
    if (transId && transOwner) {
      return `${baseURL}services/transactionservice/api/renderReceipt?transId=${transId}&transOwner=${transOwner}`
    }
    return ''
  }

  if (isSafari) {
    return null;
  }

  return (
    <React.Fragment>
      <button
        className={['btn-lg btn-default print_no_display', styles['print_save_margin']].join(' ')}
        value={t('receive_confirmation.print_receipt')}
        name={t('receive_confirmation.print_receipt')}
        onClick={printClick}
      >
        <i className={['fa fa-print', styles['print_icon']].join(' ')} aria-hidden="true"></i>
        {t('receive_confirmation.print_receipt')}
      </button>
    </React.Fragment>
  )
}

export default withTranslation('common')(PrintComponent)
